<section class="widget-page">
  <div class="d-flex align-items-center gap-3 mb-3">
    <div class="d-flex align-items-center gap-2">
      <h6 class="mb-0 page-title" i18n>Interstitial Widget</h6>
      <app-page-help [articleId]="'2gaj1ej34d'" videoId="-"></app-page-help>
    </div>
    <div class="flex-fill"></div>
    <a routerLink="/widgets" class="btn btn-secondary-primary">
      <i class="far fa-chevron-left"></i> <ng-container i18n>Back to Widgets</ng-container>
    </a>
  </div>
  <div class="main-content">
    <div class="container-box details-box">
      <div class="box-body">
        <div class="row">
          <div class="col-lg-6 col-xl-5">
            <div class="widget-holder p-3">
              <div class="alert alert-secondary-info">
                <i class="cs-icon cs-icon-info-circle alert-icon"></i>
                <div class="aler-content" i18n>
                  First select the booking engine, then configure the widget as you like.
                </div>
              </div>

              <form [formGroup]="form">
                <div class="clearfix widget-box">
                  <h4 class="title">
                    <ng-container i18n>1. Select a booking engine</ng-container> <span class="red-star">*</span>
                  </h4>
                  <div class="row">
                    <div class="col-sm-12">
                      <app-select-search
                        bindLabel="title"
                        [inline]="false"
                        [multiple]="false"
                        [items]="websiteEngines$ | async"
                        [ctrl]="form.get('engine')"
                        placeholder="Engine"
                      ></app-select-search>
                    </div>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <h4 class="title">
                    <ng-container i18n>2. Widget Type</ng-container> <span class="red-star">*</span>
                  </h4>
                  <div class="row">
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <mat-select i18n-placeholder placeholder="Type" formControlName="type">
                          <mat-option value="button">Button</mat-option>
                          <mat-option value="inlineForm">Inline Form</mat-option>
                        </mat-select>
                      </mat-form-field2>
                    </div>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <h4 class="title">
                    <ng-container i18n>3. Widget Style</ng-container> <span class="red-star">*</span>
                  </h4>
                  <h4 class="title" i18n>General</h4>
                  <div class="row">
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <mat-select i18n-placeholder placeholder="Font Family" formControlName="fontFamily">
                          <mat-option i18n>Default</mat-option>
                          <mat-option *ngFor="let item of fontFamilies" [value]="item">
                            {{ item }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6">
                      <div class="toggle-control">
                        <label class="form-field-label" i18n>Price</label>
                        <app-form-switch formControlName="showPrice"></app-form-switch>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                      <div class="toggle-control">
                        <label class="form-field-label" i18n>Minimum Stay</label>
                        <app-form-switch formControlName="showMinimumStay"></app-form-switch>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                      <div class="toggle-control">
                        <label class="form-field-label" i18n>Total Price</label>
                        <app-form-switch formControlName="showTotalCost"></app-form-switch>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                      <div class="toggle-control">
                        <label class="form-field-label" i18n>Input Label</label>
                        <app-form-switch formControlName="showInputLabel"></app-form-switch>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                      <div class="toggle-control">
                        <label class="form-field-label" i18n>Input Placeholder</label>
                        <app-form-switch formControlName="showInputPlaceholder"></app-form-switch>
                      </div>
                    </div>
                  </div>

                  <div class="title" i18n>Buttons</div>
                  <div class="row">
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          formControlName="bookButtonText"
                          i18n-placeholder
                          placeholder="Book Button Text"
                          required
                        />
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          formControlName="enquiryButtonText"
                          i18n-placeholder
                          placeholder="Inquiry Button Text"
                          required
                        />
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          formControlName="sendInquiryButtonText"
                          i18n-placeholder
                          placeholder="Send Inquiry Button Text"
                          required
                        />
                      </mat-form-field2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <mat-form-field2 class="mat-block">
                        <input
                          matInput
                          [value]="form.get('buttonColor').value"
                          i18n-placeholder
                          placeholder="Button Color"
                          [colorPicker]="form.get('buttonColor').value"
                          [cpOutputFormat]="'hex'"
                          [cpPosition]="'bottom'"
                          (colorPickerChange)="onColorSelected('buttonColor', $event)"
                        />
                        <mat-icon
                          matSuffix
                          fontSet="fas"
                          fontIcon="fa-circle"
                          class="color-picker-value-indicator"
                          [style.color]="form.get('buttonColor').value"
                        ></mat-icon>
                      </mat-form-field2>
                    </div>
                    <div class="col-sm-6">
                      <mat-form-field2>
                        <input
                          matInput
                          type="number"
                          formControlName="buttonBorderRadius"
                          i18n-placeholder
                          placeholder="Border Radius"
                        />
                      </mat-form-field2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <mat-form-field2>
                        <input
                          matInput
                          type="number"
                          formControlName="buttonBorderWidth"
                          i18n-placeholder
                          placeholder="Border Width"
                        />
                      </mat-form-field2>
                    </div>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <div class="alert alert-dark">
                    <p i18n>Widget Code</p>
                    <pre class="widget-code" [innerText]="widgetCode"></pre>
                  </div>
                </div>

                <div class="clearfix widget-box">
                  <h4 class="title" i18n>4. Copy and paste the desired widget code onto your website.</h4>
                  <div class="row">
                    <div class="col-sm-12 btn-holder">
                      <button
                        type="button"
                        class="btn btn-secondary-light"
                        [disabled]="!widgetCode"
                        ngxClipboard
                        [cbContent]="widgetCode"
                        (cbOnSuccess)="onCopied($event)"
                      >
                        <span class="fal fa-copy"></span>
                        <ng-container i18n>copy code</ng-container>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-lg-6 col-xl-7">
            <div class="widget-preview d-flex align-items-center flex-column h-100 p-3">
              <h5 class="title text-light" i18n>Widget Preview</h5>

              <div
                class="preview-box flex-fill w-100"
                *ngIf="trustedWidgetCode"
                [style.height.px]="preview?.contentWindow?.document?.documentElement?.scrollHeight"
              >
                <iframe [srcdoc]="trustedWidgetCode" frameborder="0" class="w-100 h-100" #preview></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
